/* Prepared cart transport. Explicitly disabled until launch and checkout validation. */
(() => {
  'use strict';
  const launch=JSON.parse(document.getElementById('r2r-bundle-live-config')?.textContent||'{}');
  const enabled = launch.enabled === true;
  const miniRestockPending = false;
  const miniGiftData=JSON.parse(document.getElementById('r2r-fan-model-data')?.textContent||'{}').mini;
  const miniGiftAvailable=miniGiftData?.available===true && (miniGiftData.stock>=1 || launch.miniPreorder===true);
  let pending = false;
  const upgradeStorage='r2r-cart-set-upgrade';
  function setUpgrade(variantId, family, variantIds){sessionStorage.setItem(upgradeStorage,JSON.stringify({variantId:String(variantId),variantIds:variantIds?.map(String),family,expires:Date.now()+300000}));}
  function clearUpgrade(){sessionStorage.removeItem(upgradeStorage);}
  const nativeKinds = new Set(['two', 'three', 'mixed', 'gift', 'tee-fan']);
  function preorderProperties(kind) {
    const pl=document.documentElement.lang.startsWith('pl');
    return {_r2r_mini_preorder:'2026-11-10',_r2r_mini_mixed:kind==='mini'?'false':'true',[pl?'Termin wysyłki mini':'Mini dispatch date']:pl?'Wysyłka od 10 listopada 2026':'Shipping from 10 November 2026',[pl?'Dosyłka mini w Polsce':'Mini follow-up delivery in Poland']:pl?'Przy mieszanym zamówieniu Orlen Paczką na nasz koszt':'For mixed orders: Orlen Paczka at our expense'};
  }
  function lines(kind, ids) {
    if (!Array.isArray(ids) || !ids.length) throw new Error('Invalid selection');
    const values = ids.map(id => String(id).split('/').pop());
    if (values.some(id => !/^\d+$/.test(id))) throw new Error('Invalid variant');
    if (miniRestockPending && ((kind==='mixed'||(kind==='gift'&&!miniGiftAvailable)) || (kind === 'mini' && values.length > 2) || (kind === 'tee-fan' && values.includes('54825253568850')))) throw new Error('Awaiting mini restock');
    if (nativeKinds.has(kind)) {
      const bundle = window.R2RNativeBundleDrafts?.resolve(kind, values);
      if (!bundle) throw new Error('Unknown bundle');
      return [{ id: bundle.id, quantity: 1, ...(values.includes('54825253568850') ? {properties: preorderProperties(kind)} : {}) }];
    }
    if (kind === 'mini') {
      if(values.length===2 && launch.miniTwoAvailable!==true)throw new Error('Mini two-pack unavailable');
      if (values.some(id => id !== '54825253568850') || values.length > 3) throw new Error('Invalid mini set');
      return [{ id: ['54825253568850', '55111094600018', '55111094567250'][values.length - 1], quantity: 1, properties: preorderProperties(kind) }];
    }
    if (kind !== 'tees' || ![2, 3].includes(values.length)) throw new Error('Invalid tee set');
    const items = new Map();
    values.forEach(id => items.set(id, (items.get(id) || 0) + 1));
    return Array.from(items, ([id, quantity]) => ({ id, quantity }));
  }
  async function add(button, kind, ids) {
    if (!enabled) return false;
    if (pending) return true;
    pending = true;
    const previous = button.disabled;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const pl = document.documentElement.lang.startsWith('pl');
    const oldError = button.parentElement.querySelector('[data-r2r-cart-error]');
    oldError?.remove();
    try {
      const items = lines(kind, ids);
      const root = window.Shopify?.routes?.root || '/';
      let upgrade=null;
      try{upgrade=JSON.parse(sessionStorage.getItem(upgradeStorage)||'null');}catch{}
      const family=kind==='mini'?'mini':['two','three','gift'].includes(kind)?'large':kind==='tees'?'tees':kind==='tee-fan'?'tee-fan':null;
      let endpoint='cart/add.js',body={items};
      if(upgrade?.expires>Date.now()&&upgrade.family===family){
        const currentResponse=await fetch(root+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
        if(!currentResponse.ok)throw new Error('Cart unavailable');
        const current=await currentResponse.json(),source=current.items?.find(i=>String(i.variant_id)===upgrade.variantId);
        if(source){
          const updates=upgrade.family==='tees'&&Array.isArray(upgrade.variantIds)?Object.fromEntries(current.items.filter(i=>upgrade.variantIds.includes(String(i.variant_id))).map(i=>[i.key,0])):{[source.key]:source.quantity-1};
          for(const item of items){const existing=current.items.find(i=>String(i.variant_id)===String(item.id));const key=existing?.key||String(item.id);updates[key]=(updates[key]??existing?.quantity??0)+item.quantity;}
          endpoint='cart/update.js';body={updates};
        }
      }
      // Never clear the cart or retry a POST automatically: either could lose/duplicate items.
      const response = await fetch(root + endpoint, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const result = await response.json().catch(() => null);
      if (!response.ok || !Array.isArray(result?.items)) throw new Error(result?.description || result?.message || 'Cart rejected selection');
      sessionStorage.removeItem(upgradeStorage);
      // Shopify's cart page is the authority for availability, tax and final discounts.
      window.location.assign(root + 'cart');
    } catch (error) {
      console.warn('R2R bundle add failed:',error.message);
      const message = document.createElement('p');
      message.dataset.r2rCartError = '';
      message.setAttribute('role', 'alert');
      message.textContent = pl
        ? 'Nie udało się potwierdzić dodania zestawu. Sprawdź koszyk przed ponowną próbą.'
        : 'We could not confirm your set was added. Check your cart before trying again.';
      button.insertAdjacentElement('afterend', message);
    } finally {
      pending = false;
      button.disabled = previous;
      button.removeAttribute('aria-busy');
    }
    return true;
  }
  window.R2RBundleCart = Object.freeze({ enabled, miniRestockPending, miniGiftAvailable, miniTwoAvailable: launch.miniTwoAvailable === true, lines, add, setUpgrade, clearUpgrade });
})();
